import React, { useState } from 'react';
import CategoryProductsModal from '../shared/CategoryProductsModal';
import PermissionGate from '../shared/PermissionGate';
import { PERMISSIONS } from '../../constants/permissionMappings';

const CategoriesTable = ({ categories, onDelete, onCreateClick }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleViewProducts = (category) => {
    setSelectedCategory(category);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCategory(null);
  };
 if (categories.length === 0) {
   return (
     <div className="bg-white rounded-lg shadow-md p-6 text-center">
       <p className="text-gray-500 mb-4">No categories found. Create your first category to get started.</p>
       <PermissionGate permission={PERMISSIONS.categories.create}>
         <button
           onClick={onCreateClick}
           className="px-4 py-2 bg-brand text-white rounded-lg hover:bg-brand-hover font-semibold transition-colors"
         >
           Create Category
         </button>
       </PermissionGate>
     </div>
   );
 }

 const handleDelete = async (categoryId) => {
   if (window.confirm('Are you sure you want to delete this category?')) {
     await onDelete(categoryId);
   }
 };

 return (
   <>
     <div className="bg-white shadow-md rounded-lg overflow-hidden">
       <div className="overflow-x-auto">
         <table className="min-w-full divide-y divide-gray-200">
         <thead className="bg-gray-50">
           <tr>
             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Name
             </th>
             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Products
             </th>
             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Created At
             </th>
             <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
               Actions
             </th>
           </tr>
         </thead>
         <tbody className="bg-white divide-y divide-gray-200">
           {categories.map(category => (
             <tr key={category.id} className="hover:bg-gray-50">
               <td className="px-6 py-4 whitespace-nowrap">
                 <div className="text-sm font-medium text-gray-900">{category.name}</div>
                 {category.description && (
                   <div className="text-sm text-gray-500">{category.description}</div>
                 )}
               </td>
               <td className="px-6 py-4 whitespace-nowrap">
                 <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">
                   {category.productCount || 0}
                 </span>
               </td>
               <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                 {new Date(category.createdAt).toLocaleDateString()}
               </td>
               <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                 <button
                   onClick={() => handleViewProducts(category)}
                   className="text-blue-600 hover:text-blue-900 mr-4 transition-colors"
                 >
                   View
                 </button>
                 <PermissionGate permission={PERMISSIONS.categories.delete}>
                   <button
                     onClick={() => handleDelete(category.id)}
                     className="text-red-600 hover:text-red-900 transition-colors"
                   >
                     Delete
                   </button>
                 </PermissionGate>
               </td>
             </tr>
           ))}
         </tbody>
       </table>
     </div>
   </div>
   
   <CategoryProductsModal 
     category={selectedCategory}
     isOpen={modalOpen}
     onClose={handleCloseModal}
   />
   </>
 );
};

export default CategoriesTable;